<template>
    <base-drawer
        :open="drawers.open"
        :close="drawers.close"
        @onOpen="drawers.show = true"
        @onClose="onCloseCustomerDrawer"
        :title="getDrawerTitle()">
        <sales-select-customer
            v-if="drawers.show && !selectedCustomer"
            :selectedCustomer="customer || {}"
            :customers="customerList"
            @setCustomer="selectCustomer"
            @addCustomer="() => addCustomer({ phone })"
        />
        <div v-if="drawers.show && selectedCustomer">
            <sales-customer v-if="!editMode && selectedCustomer.id" :configurations="storeConfigurations" :key="drawers.index" :customer="selectedCustomer"/>
            <sales-customer-form
                v-else-if="drawers.show && selectedCustomer"
                ref="customerForm"
                :configurations="storeConfigurations"
                :key="drawers.index"
                :customer="selectedCustomer"
                :role="Role.CUSTOMER"
                @setCustomer="updateSelectedCustomer"
                @save="saveCustomer"/>
        </div>

        <!-- Não aparece na seleção de cliente (Quando estiver aparecendo o SalesSelectCustomer) -->
        <template v-slot:footer v-if="selectedCustomer
 && selectedCustomer.type !== 'F'">
            <div class="d-flex">
                <div v-if="!editMode" class="d-flex w-100">
                    <!--
                        Botão de trocar cliente para a funcionalidade de multiplos clientes
                        <base-button
                            @click="selectedCustomer = null"
                            :text="'Trocar cliente'"
                            class="w-100 mr_7"
                            design="two"
                        />
                    -->
                    <base-button @click="editMode = true" :text="'Editar'" class="w-100 big" />
                </div>
                <div v-else class="d-flex w-100">
                    <base-button @click="cancelEdit" text="Cancelar" class="w-100 mr_7 big" design="four"  />
                    <base-button
                        @click=" triggerFormSave" 
                        :text="selectedCustomer.id ? 'Salvar' : 'Criar'"
                        class="w-100 ml_7 big"/>
                </div>
            </div>
        </template>
    </base-drawer>
</template>
<script>
    import BaseDrawer from "@/components/Drawer";
    import BaseButton from "@/components/Button";

    import SalesCustomer from "@/containers/Sales/SalesCustomer/SalesCustomer";
    import SalesCustomerForm from "@/containers/Sales/SalesCustomer/SalesCustomerForm";
    import SalesSelectCustomer from "@/containers/Sales/SalesCustomer/SalesSelectCustomer";

    import {Role} from "easyjs/lib/Role/Group";

    import Utils from "@/utils";
    import {getXAPIEnv} from '@/plugins/account'

    import AccountApi from '@/api/account';
    import UserApi from '@/api/user';
    import CustomerApi from "@/api/customer";

    import Customer from '@/containers/Customer';
    import Location from "@/plugins/core/schema/configurations/BasicInfo/Location";
    import Geolocation from "easyjs/lib/Schema/Address/Geolocation";
    import Delivery from "easyjs/lib/Schema/Delivery/index";

    export default {
        components : {
            BaseDrawer,
            BaseButton,
            SalesCustomer,
            SalesCustomerForm,
            SalesSelectCustomer
        },
        props : {
            phone: {
                type: String,
                default: ""
            },
            customers: {
                type: [
                    Array, Object
                ],
                default: []
            },
            customer: {
                type: Object,
                default: null
            },
            open: {
                type: Boolean,
                default: false
            },
            storeConfigurations: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                Role,
                selectedCustomer: null,
                customerList: [],
                editMode: false,
                drawers: {
                    index: 0,
                    open: false,
                    close: false,
                    show: false
                }
            }
        },
        mounted() {
            if(!this.editMode && this.customer && !this.customer.id && !this.customerList.length) {
                this.editMode = true;
            }
        },
        updated() {
            if(!this.editMode && this.customer && !this.customer.id && !this.customerList.length) {
                this.editMode = true;
            }
        },
        methods : {
            getDrawerTitle() {
                const {selectedCustomer} = this;
                if (selectedCustomer) {
                    return (selectedCustomer.id ? 'Ver cliente' : 'Novo cliente')
                } else {
                    return 'Selecionar cliente'
                }
            },
            triggerFormSave() {
                                this.drawers.close = !this.drawers.close;
                this.$refs.customerForm.save();
            
            },
            async selectCustomer(customer) {
                await this.setCustomer(customer);
            },
            async setCustomer(customer) {
                this.updateSelectedCustomer(customer);

                if (customer.id) {
                    await this.loadUserConfigurations();
                }

                this.$emit('setCustomer', customer);
            },
            addCustomer(newCustomer) {
                this.$set(this, 'selectedCustomer', newCustomer);
                this.editMode = true;
            },
            onCloseCustomerDrawer() {
                this.editMode = false;
                this.drawers.show = false;
                if(this.customer && this.customer.id){
                    this.selectedCustomer = this.customer;
                } else {
                    this.selectedCustomer = null
                }
                this.$emit('onCloseCustomerDrawer');
            },
            cancelEdit() {
                if (!this.selectedCustomer.id) {
                    this.selectedCustomer = null;
                }

                this.editMode = false;
                if(!this.customers || this.customers.length == 0) {
                    this.drawers.close = !this.drawers.close;
                }
            },
            async loadUserConfigurations() {
                const userId = this.selectedCustomer.id;
                const environmentAlias = getXAPIEnv();

                const userConfigurationsResponse = await CustomerApi.GetConfigurations(userId, false);
                const defaultObject = {
                    flags: {
                        [environmentAlias]: 0
                    },
                    addresses: [],
                    annotations: [null]
                };
                const {flags, addresses: addressesData, annotations} = userConfigurationsResponse.getData(defaultObject);
                this.$set(this.selectedCustomer, "addresses", addressesData);
                this.$set(this.selectedCustomer, "annotation", annotations.length > 0 ? annotations[0] : null);
                this.$forceUpdate();
            },
            updateSelectedCustomer(customer) {
                if(customer) {
                    if(!customer.annotation) {
                        customer.annotation = { annotation: "" }
                    }

                    if(!customer.addresses) {
                        customer.addresses = []
                    }

                    if(!customer.phone) {
                        customer.phone = ""
                    }
                }

                this.selectedCustomer = customer
            },
            async saveCustomer(formCustomer) {
                try {

                    let isSuccessCustomer = false;
                    let newCustomer = null;

                    const customer = Object.clone(formCustomer);

                    const addresses = Object.clone(customer.addresses);
                    delete customer.addresses;

                    const annotation = Object.clone(customer.annotation);
                    delete customer.annotation;

                    if (!customer.id) {
                        const userResponse = await UserApi.associateCustomer({
                            ...customer,
                            birthdate: customer.birthdate
                                ? Utils.br2Iso(customer.birthdate)
                                : null
                        });

                        if (userResponse.getErrors([]).length > 0) {
                            alert(userResponse.getErrors(["Ocorreu um erro ao salvar o cliente!"])[0]);
                            return;
                        } else {
                            const userData = userResponse.getData({});
                            if (userData.id) {
                                newCustomer = userData;
                                isSuccessCustomer = true;
                                customer.id = newCustomer.id;
                            }
                        }
                    } else {
                        const customerId = customer.id;
                        delete customer.id;
                        const userResponse = await UserApi.customer(customerId, {
                            ...customer,
                            birthdate: customer.birthdate
                                ? Utils.br2Iso(customer.birthdate)
                                : null
                        });

                        if (userResponse.getErrors([]).length > 0) {
                            alert(userResponse.getErrors(["Ocorreu um erro ao salvar o cliente!"])[0]);
                            return;
                        } else {
                            const userData = userResponse.getData({});
                            if (userData.id) {
                                newCustomer = userData;
                                isSuccessCustomer = true;
                                customer.id = newCustomer.id;
                            }
                        }
                    }

                    if (!newCustomer) {
                        return;
                    }

                    isSuccessCustomer = isSuccessCustomer && await this.saveAnnotation(annotation.annotation, customer.id);
                    isSuccessCustomer = isSuccessCustomer && await this.saveAddresses(addresses, customer.id);

                    if (isSuccessCustomer) {
                        await this.setCustomer(customer);
                        this.editMode = false;
                    }

                } catch (err) {
                    console.error(err);
				}

				this.drawers.close = !this.drawers.close;

                return;
            },
            async saveAnnotation(annotation, customerId) {
                try {
                    const customerAnnotation = this.selectedCustomer.annotation;
                    if (!!customerAnnotation && customerAnnotation.id) { //Se já existir anotação
                        if (!!annotation) { //Se a anotação for definida
                            const response = await CustomerApi.addAnnotation(customerId, annotation);
                            return !!response.getData({ id: null }).id;
                        } else { //Se a anotação não for definida
                            const response = await CustomerApi.deleteAnnotation(customerId);
                            return response.getCode(500) == 200;
                        }
                    } else { // Se não existir anotação
                        if (!!annotation) { //Se a anotação for definida
                            //Salvar anotação
                            const response = await CustomerApi.addAnnotation(customerId, annotation);
                            return !!response.getData({ id: null }).id;
                        }
                    }

                } catch (err) {
                    console.error(err);
                    return false;
                }

                return true;
            },
            async saveAddresses(addresses, customerId) {
                try {
                    for (var addressIndex in addresses) {
                        let address = addresses[addressIndex];
                        if (typeof address != 'object') {
                            continue;
                        }

                        if (!!address.id) {
                            if (!!address.deleted) {
                                const deleteResponse = await AccountApi.deleteUserAddress(address.id, customerId);
                                if (deleteResponse.getErrors([]).length > 0) {
                                    alert("Ocorreu erro ao excluir um endereço.");
                                }
                            }
                            continue;
                        }

                        if (!!address.deleted) {
                            continue;
                        }

                        delete address.countryCode;
                        delete address.realPosition;

                        address.region = address.district;

                        delete address.district;
                        address.number += '';

                        const addResponse = await AccountApi.addUserAddress(customerId, address);
                        if (addResponse.getErrors([]).length > 0) {
                            if (!address.geolocation) {
                                alert(response.getErrors([])[0]);
                            }
                        }
                    }
                } catch (err) {
                    console.error(err);
                    return false;
                }

                return true;
            }
        },
        watch: {
            open: {
                handler(newValue) {
                    if(this.drawers.open != newValue) {
                        this.drawers.open = newValue;
                    }
                }
            },
            customers: {
                deep: true,
                handler(newValue) {
                    this.customerList = newValue;
                }
            },
            customer: {
                deep: true,
                handler(newValue) {
                    this.selectedCustomer = newValue;
                    if(this.editMode) {
                        this.editMode = false;
                    }
                }
            }
        }
    }
</script>